export default __webpack_public_path__ + "static/media/p3-20.9a2c1d1f.png";